import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter);

function lazyLoad(view){
    return() => import(`@/views/${view}/${view}.vue`)
}

const routes = [
    {
        path: '/',
        name: 'home',
        component: lazyLoad('home')
    },
    {
        path: '/privacy',
        name: 'privacy',
        component: lazyLoad('privacy')
    },
    {
        path: '/thanks',
        name: 'thanks',
        component: lazyLoad('thanks')
    },
    {
        path: '/404',
        name: '404',
        component: lazyLoad('404')
    },
    {
        path: '*',
        redirect: '/404'
    }
];

export default new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
});
